import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import * as requests from '../api/requests';
import {
  addNotification,
  addErrorNotification,
  addWarningNotification,
} from './notificationsSlice';

const initialState = {
  ok: null,
  history: {},
  lastVerifiedId: null,
  lastFailedId: null,
};

// ---------------------- ASYNC THUNK ----------------------

export const verifyCert = createAsyncThunk(
  'verify/verifyCert',
  async (args, thunkAPI) => {
    const { certificateId, latitude, longitude } = args;
    const { lastVerifiedId, lastFailedId } = thunkAPI.getState().verify;

    try {
      const res = await requests.verifyCert(certificateId, latitude, longitude);
      const body = await res.json();

      // Check body.ok (verification result) instead of res.ok (HTTP status)
      if (body.ok && lastVerifiedId !== certificateId) {
        if (!body.unusualActivity) {
          thunkAPI.dispatch(addNotification('Verification Successful!'));
        } else {
          thunkAPI.dispatch(
            addWarningNotification(
              'Verification Successful! However, there is unusual activity.'
            )
          );
        }
      } else if (!body.ok && lastFailedId !== certificateId) {
        const errmsg = body.message || body.errmsg || 'Verification failed. Invalid certificate.';
        thunkAPI.dispatch(addErrorNotification(errmsg));
      }

      return {
        ok: body.ok,
        body,
        history: body.history || {},
        certificateId,
      };
    } catch (error) {
      thunkAPI.dispatch(addErrorNotification('Network error. Try again.'));
      return {
        ok: false,
        body: {},
        history: {},
        certificateId,
      };
    }
  }
);

// ---------------------- SLICE ----------------------

const verifySlice = createSlice({
  name: 'verify',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder.addCase(verifyCert.fulfilled, (state, { payload }) => {
      const { ok, history, certificateId } = payload;

      state.ok = ok;
      state.history = history;

      if (ok) {
        state.lastVerifiedId = certificateId;
        state.lastFailedId = null;
      } else {
        state.lastFailedId = certificateId;
        state.lastVerifiedId = null;
      }
    });
  },
});

export default verifySlice.reducer;
